import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom';
import { inject, observer } from 'src/core/store'
import './index.less'

let timer = null

@inject('store')
@observer
export default class UserList extends Component {

  constructor(props) {
    super(props)
    this.fruitStore = this.props.store.register('activity/fruit')
  }
  state = {
    userList: [],
    second: "",
    later: "0%"
  }

  async componentWillMount() {
    let userList = await this.fruitStore.getGameUserList()
    this.setState({
      userList: userList
    })
    let containerWidth = document.querySelector('.marquee-container').offsetWidth
    let boxWidth = document.querySelector('.marquee-container .marquee-box').offsetWidth
    let duration = ((boxWidth * 2 + containerWidth) / 200) + 's'
    await this.setState({
      second: duration
    })
    await this.setState({
      later: "-100%"
    })
    // this.time(((boxWidth * 2 + containerWidth) / 600) * 1000)
  }

  // async time(val) {
  //   timer = setTimeout(async () => {
  //     console.log("end")
  //     let userList = await this.fruitStore.getGameUserList()
  //     console.log(userList, 'userList')
  //     this.setState({
  //       userList: userList
  //     })
  //     let containerWidth = document.querySelector('.marquee-container').offsetWidth
  //     let boxWidth = document.querySelector('.marquee-container .marquee-box').offsetWidth
  //     let duration = ((boxWidth * 2 + containerWidth) / 200) + 's'
  //     this.time(((boxWidth * 2 + containerWidth) / 200) * 1000)
  //   }, val)
  // }

  componentWillUnmount() {
    clearInterval(timer)
  }

  componentWillReceiveProps() {
    console.log('更新了')
  }

  render() {
    const langTxt = () => {
      if (this.props.lang == 'zh') {
        return '赢得了'
      } else if (this.props.lang == 'ar') {
        return 'حصل علي'
      } else if (this.props.lang == 'en') {
        return 'won'
      } else {
        return 'won'
      }
    }
    return (
      <div className="marquee-container">
        <div className="marquee-box" style={{
          animationDuration: `${this.state.second}`
          // transition: `all ${this.state.second} linear`,
          // transform: `translateX(${this.state.later})`
        }}>
          {
            this.state.userList && this.state.userList.map((item, index) => {
              // if (index < 2) {
              return (
                <div className="list-item" key={index}>
                  <div className="ava">
                    <img src={item.avatar_url} alt="" />
                  </div>
                  <div className="txt">{langTxt()}</div>
                  <div className="gift">
                    <img src="/img/gold.png" alt="" />
                  </div>
                  <div className="x">
                    x
                  </div>
                  <div className="num">
                    {item.gold}
                  </div>
                </div>
              )
              // }
            })
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/fruit1103/UserList/index.js